import { Injectable, inject, ApplicationRef } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, concat, EMPTY } from 'rxjs';
import { first, switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PeriodicUpdateCheckerService {
  private swUpdate = inject(SwUpdate);
  private appRef = inject(ApplicationRef);

  constructor() {
    this.initializePeriodicCheck();
    this.initializeVisibilityCheck();
  }

  private initializePeriodicCheck(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // Wait for app to stabilize, then check every 30 minutes
    const appIsStable$ = this.appRef.isStable.pipe(
      first(isStable => isStable === true)
    );
    
    const periodicCheck$ = interval(30 * 60 * 1000); // 30 minutes
    
    const periodicCheckOnceStable$ = concat(
      appIsStable$,
      periodicCheck$
    );

    periodicCheckOnceStable$.subscribe(async () => {
      try {
        const updateFound = await this.swUpdate.checkForUpdate();
        if (updateFound) {
        }
      } catch (error) {
        console.error('[PeriodicUpdateChecker] Error during periodic check:', error);
      }
    });
  }

  private initializeVisibilityCheck(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // Check for updates when user returns to the tab
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.checkForUpdate();
      }
    });

    // Check for updates when user focuses the window
    window.addEventListener('focus', () => {
      this.checkForUpdate();
    });
  }

  private async checkForUpdate(): Promise<void> {
    try {
      const updateFound = await this.swUpdate.checkForUpdate();
      if (updateFound) {
      }
    } catch (error) {
      console.error('[PeriodicUpdateChecker] Error during visibility check:', error);
    }
  }
} 